import { CHAT_ICONS } from './chatIcons'

// One markup object per icon: React compares dangerouslySetInnerHTML by
// identity, so a fresh object each render would re-parse the SVG every time.
const MARKUP = new Map(Object.entries(CHAT_ICONS).map(([id, icon]) => [id, { __html: icon.body }]))

/** A CRM sprite icon (chatIcons.ts). */
export function Icon({ id, size }: { id: string; size: number }) {
  const icon = CHAT_ICONS[id]
  if (!icon) return null
  return <svg width={size} height={size} viewBox={icon.viewBox} fill="currentColor" aria-hidden="true" dangerouslySetInnerHTML={MARKUP.get(id)} />
}
